<template>
  <div class="file-upload">
    <p>投稿予定画像・動画</p>
    <p style="font-size: 12px; color: #2c3e50; text-align: center">
      ※アップロードできるファイルは30MB以内<br />
      png、jpeg、mov、mp4です
    </p>
    <div class="image-upload add-file">
      <draggable
        v-model="images"
        group="people"
        item-key="element"
        @change="changeRow"
      >
        <template #item="{ element, index }">
          <div class="upload-data">
            <img
              :src="element.display"
              style="width: 100%; height: 100%; object-fit: cover"
              crossorigin="anonymous"
            />
            <span>{{ index + 1 }}</span>
            <span v-if="element.duration"> {{ element.duration }}</span>
            <div class="close" @click="deleteFile(index)"></div>
          </div>
        </template>
      </draggable>
      

      <input
        id="file"
        type="file"
        multiple
        accept="image/png, image/jpeg,image/heif, video/mov, video/mp4, capture=camera"
        @change="upload"
        ref="file"
      />
    </div>
    <label for="file" v-if="images.length < 20">
        <img src="../assets/add-file.svg"  id="add_file"/>
      </label>
    <div class="button-area">
      <common-button
        :data="{
          status: images.length ? 0 : 2,
          button: `ファイルをアップロードする`,
        }"
        @click="images.length ? uploadFile() : ''"
      ></common-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import draggable from "vuedraggable";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import router from "../router";

const images = ref<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { url: string; display: string; file: any; duration: string }[]
>([]);
const error = ref<string[]>([]);
const projectStore = ProjectStore();
const commonStore = CommonStore();
const showAlert = ref(false);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const requestParam = ref<any[]>([]);
const params = new FormData();

onMounted(() => {
  // ブラウザバックした時に追加したファイルがデフォルトで入るようにする
  // 下書き再提出の場合は画像は再アップロードしてもらう
  if (projectStore.fileUploadList.get(projectStore.selectedId)?.length) {
    // if (projectStore.fileUploadList.get(projectStore.selectedId)?.find((v) => v.url.includes("https://omi-liff"))) {
    //   images.value = []
    // } else {
    // images.value = projectStore.fileUploadList.get(projectStore.selectedId) || []
    // }
    images.value =
      projectStore.fileUploadList.get(projectStore.selectedId) || [];
  }
});

// 動画時間を取得する
function getDuararion(duration: number): string {
  if (!duration) return "";
  const min = Math.trunc(Math.round(duration) / 60);
  const second = Math.round(duration - min * 60);
  return min + ":" + String(second).padStart(2, "0");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function upload(event: any) {
  await checkFiles(event);

  if (error.value.length) {
    commonStore.setToast({
      showToast: true,
      message: error.value.join("\n"),
      state: 1,
      timeout: 5000,
    });
    showAlert.value = true;
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function checkFiles(event: any) {
  error.value.splice(0, error.value.length);
  const fileLimit = 1024 * 1024 * 30;
  const files = Array.from(event.target.files);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  files.forEach(async (v: any,index:number) => {
    if (v.size > fileLimit) {
      error.value.push(
        `${v.name}: \r\n ファイルサイズが30MBを超えているため\r\nアップロードできません\r\nファイルの圧縮をお願いいたします`
      );
    } else if (index > 19 || images.value.length == 20) {
      if (
        error.value.find(
          (v) =>
            v ==
            `\r\n ファイルアップロード数は20件までのため\r\nアップロードできません`
        )
      )
        return;
      error.value.push(
        `\r\n ファイルアップロード数は20件までのため\r\nアップロードできません`
      );
    } else {
      const file = v;
      // new RegExp("^image/(png|jpeg)"
      if (file.type.match(/image/)) {
        const url = URL.createObjectURL(file);
        images.value.push({
          url: url,
          display: url,
          file: file,
          duration: "",
        });
      } else if (file.type.match(/video/)) {
        // サムネイルを生成する
        const url = URL.createObjectURL(file);
        // let display = ''
        file.onload = () => {};
        await createThumbnail(url).then((v) => {
          images.value.push({
            url: url,
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            display: v.thumbnail,
            file: file,
            duration: getDuararion(v.duration),
          });
          params.append("file", file, file.name);
          requestParam.value.push(params);
        });
      }
    }
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function createThumbnail(url): Promise<any> {
  return new Promise(function (promise) {
    const video = document.createElement("video");

    const thumbnailFrame = 0; // サムネイル取得秒指定

    video.preload = "metadata";
    video.src = url;
    video.hidden = true;
    // Safari / IE11
    video.muted = true;
    video.playsInline = true;
    video.currentTime = thumbnailFrame;
    // video.play();
    video.play().catch(() => promise({
        // eslint-disable-next-line @typescript-eslint/no-require-imports
          thumbnail: require("../assets/video.svg"),
          duration: 0,
    }))

    // timeupdateイベントで動画の再生を検知しています
    const timeupdate = function () {
      snapImage();
    };

    // 2.選択された動画を新規生成した<video>要素で再生
    video.addEventListener("timeupdate", timeupdate);

    video.addEventListener("canplay", function () {
      if (video.duration > thumbnailFrame) {
        video.currentTime = thumbnailFrame;
      } else {
        video.currentTime = video.duration / 2;
      }
    });
    const snapImage = function () {
      // 3.再生後、さらに新規生成した<canvas>要素で描画
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      // 4.描画後にtoDataURL()関数を利用して画像blobを取得、適宜<img>要素へ適応
      const image = canvas.toDataURL("image/png");
      const success = image.length > 100000;
      if (success) {
        setTimeout(() => {
          // Safari対策
          URL.revokeObjectURL(url);
        }, 2000);
        return promise({ thumbnail: image, duration: video.duration });
      } else {
        // サムネイル生成失敗した場合は仮のサムネイル配置
        return promise({
        // eslint-disable-next-line @typescript-eslint/no-require-imports
          thumbnail: require("../assets/video.svg"),
          duration: video.duration || 0,
        });
      }
    };
  });
}
function deleteFile(index: number) {
  images.value.splice(index, 1);
}
async function uploadFile() {
  projectStore.setFileUploadList(projectStore.selectedId, images.value);
  projectStore.uploadResource(images.value);
  // projectStore.setSelectedId(+route.query.projectId);
  router.push("draft")
  // router.push({ name: "draft", query: { content: route.query.content || "" } });
  // router.back();
  // 下書きを送信する
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function changeRow(event: any) {
  const tmpList = images.value.filter((v) => v != event.moved.element);
  images.value.splice(0, images.value.length);
  images.value.push(...tmpList);
  images.value.splice(event.moved.newIndex, 0, event.moved.element);
}

// function preview(url: string) {
//   window.open(url);
// }
</script>
<style scoped lang="scss">
@import "../assets/style/_variables.scss";
template:nth-of-type(2) {
  display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  // text-align: center;
  
}
.file-upload {
  overflow-y: auto;
  height: 100%;
}
.file-upload::-webkit-scrollbar {
  display: none;
}
.image-upload > input {
  display: none;
}
.add-file {
  display: block;
  text-align: center;
  // width: 64px;
  // height: 64px;
  // margin-left: 40px;
  margin: 24px 20px;
  margin-bottom: 50px;
}
#add_file {
  margin-left: 40px;
  margin-bottom: 150px;
}
.error-message {
  color: red;
}
.text-area {
  width: 295px;
  height: 513px;
  padding-left: 8px;
  padding-top: 8px;
  margin: auto 40px;
  overflow-y: auto;
}
.btn-contact {
  margin-right: 10px;
  width: 200px;
  appearance: none;
  border: 0;
  border-radius: 5px;
  background: #0074ff;
  color: $white;
  padding: 8px 12px;
  font-size: $FONT_SIZE_M;
}
.btn-close {
  margin-right: 10px;
  width: 70px;
  appearance: none;
  border: 0;
  border-radius: 5px;
  background: #b2b2b2;
  color: $white;
  padding: 8px 12px;
  font-size: $FONT_SIZE_M;
}
.file-upload {
  p:nth-child(1) {
    // font-family: $font-family-hiragino-gothic-pron;
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_M;
    line-height: 18px;
    margin-left: 40px;
    padding-top: 20px;
    color: #000000;
  }
}
.upload-data {
  position: relative;
  display: inline-block;
  width: 84px;
  height: 84px;
  object-fit: cover;
  padding-right: 16px;
  span:nth-child(even) {
    position: absolute;
    text-align: center;
    bottom: -12px;
    left: 10px;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: #ffffff;
    width: 25px;
    height: 25px;
    background-color: $OMOT_COLOR;
    border-radius: 12px;
    font-size: 16px;
    margin: 0 !important;
    padding: 0 !important;
  }
  span:nth-child(odd) {
    position: absolute;
    text-align: center;
    bottom: 0px;
    right: 30px;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: #e0e0e0;
    font-weight: 700;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    font-size: $FONT_SIZE_M;
    margin: 0 !important;
    padding: 0 !important;
  }
}
.button-area {
  width: 100%;
  max-width: 480px;
  height: 56px;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
}
.close {
  position: absolute;
  display: block;
  right: 15px;
  top: 0px;
  width: 15px;
  height: 15px;
  padding: 5px;
  border: 1px solid #e0e0e0;
  background: #e0e0e0;
}
.close::before,
.close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 14px;
  background: #333;
}
.close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}
</style>
